export namespace NotificationHistoryActions {

    export class GetRecipientsAttribute {
        public static readonly type = '[NotificationHistory] Get RecipientsAttribute By ID';
        constructor(public notificationId: string) {}
    }
}